import Axios from "axios";

class ResendActivationService {
  public static async resendActivation(email: string): Promise<any> {
    const { data } = await Axios.post(
      "/api/v1/auth/users/resend_activation/",
      { email },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return data;
  }
}

export default ResendActivationService;
